import { Text } from '../../../../shared-components';
import { CheckCircle } from 'phosphor-react';
import { PROGRAMS } from './constants';
import { useMemo } from 'react';
import { Masonry } from '../../../../shared-components/masonry/Masonry';

const programs = {
  telemedicine: 'Telemedicine',
  wellness_differential: 'Wellness Differential',
  disease_management_program: 'Disease Management',
  specialty_pharmacy_program: 'Specialty Pharmacy',
  health_reimbursement_arrangement: 'Health Reimbursement Arrangement',
  health_savings_account: 'Health Savings Account',
  flexible_spending_account: 'Flexible Spending Account',
  custom: 'Custom',
};

export const programList = Object.entries(programs);

export const IncludedPrograms = ({ includedPrograms }) => {
  const includedProgramTypes = useMemo(
    () => Object.values(includedPrograms || {})?.map(({ ProgramType }) => ProgramType),
    [includedPrograms]
  );
  return (
    <Masonry.Group>
      <Masonry.Group.Title value="Included Programs" />
      <Masonry.Group.Content>
        {programList.map(([key]) => {
          if (!includedProgramTypes.includes(key)) {
            return null;
          }
          return (
            <Masonry.Group.Item
              key={key}
              flex="left"
              css={`
                gap: 16px;
              `}
            >
              <CheckCircle size={24} color="var(--accent-color-2)" weight="fill" />
              <Text label>{includedPrograms?.[key]?.RawData?.Details?.Name || PROGRAMS[key]}</Text>
            </Masonry.Group.Item>
          );
        })}
      </Masonry.Group.Content>
    </Masonry.Group>
  );
};
